import React from "react";
import { Utility } from "../../utils";
import Settings from "../../settings";

interface OwnProps {
    title?: string;
    url?: string;
}

interface OwnState {
}

export class AddThis extends React.Component<OwnProps, OwnState> {

    private _isMounted = false;

    public async componentDidMount() {
        this._isMounted = true;

        if (typeof window === "undefined")
            return;

        // make sure we have the plupload script loaded from CDN
        if (!(window as any).addthis) {
            (window as any)["addthis_config"] = { data_track_addressbar : false, pubid: "ra-500eb873783b8086" };
            await Utility.lazyLoadResource("https://s7.addthis.com/js/300/addthis_widget.js", false);
        }

        setTimeout(() => {
            if (this._isMounted) {
                (window as any)["addthis_share"].title = this.props.title || Settings.ClientName;
                (window as any)["addthis_share"].url = this.props.url || window.location.href;
                (window as any).addthis.toolbox(".addthis_inline_share_toolbox");
                (window as any).addthis.layers.refresh();
            }
        }, 1000);
    }

    public componentWillUnmount() {
        this._isMounted = false;
    }

    public render() {
        const title = this.props.title || Settings.ClientName;

        const url = !this.props.url && typeof window !== "undefined"
            ? window.location.href
            : this.props.url;

        return <div className="addthis_inline_share_toolbox" data-title={title} data-url={url}></div>;
    }
}



// WEBPACK FOOTER //
// ./src/components/generic/AddThis.tsx